import React, { act, useContext, useEffect, useRef, useState } from 'react'
import "./roam-path.less";
import { ReactComponent as RoamSvg } from '@/commons/icons/roam/roam.svg'
import { ReactComponent as TitleRoamSvg } from '@/commons/icons/roam/title-roam.svg'
import { ReactComponent as PlaySvg } from '@/commons/icons/roam/play.svg'
import { ReactComponent as PauseSvg } from '@/commons/icons/roam/pause.svg'
import { ReactComponent as BackSvg } from '@/commons/icons/roam/back.svg'
import { ReactComponent as DeleteSvg } from '@/commons/icons/roam/delete.svg'
import { ReactComponent as RoamManSvg } from '@/commons/icons/roam/roam-man.svg'
import { ReactComponent as TitleSelectOpenSvg } from '@/commons/icons/roam/title-select-open.svg'
import { RoamRoute } from '@/commons/interface/building/roam-route';
import { useParams } from 'react-router-dom';
import { findRoamRoutesByBuilding, updateRoamRoutes } from '@/api/building/roam-route';
import { message } from 'antd';
import classNames from 'classnames';
import { CatmullRomCurve3, OrthographicCamera, PerspectiveCamera, Vector3 } from 'three';
import { createTween, roamAnimate, roamCameraRotate, } from './tween';
import { SystemContext } from '@/App';
import { CAMERA_TYPE } from '../draw/viewport';
import { ContextMenuFC } from 'tncet-common';
import { getGroupByUuids } from '@/api/spec-common/group';
import { Group } from '@/commons/interface/speccommon/group';
import { removeAll } from '@tweenjs/tween.js'
import { graphicStore } from '@/commons/store/graphic-store';

//漫游时间 TODO
const RoamRotationSpeed = 15; // 旋转速度
const CameraHeight = 1500; // 旋转速度

const RoamStatus = {
    STOP: 1,
    PLAY: 2,
    PAUSE: 3
}

interface RoamGroup extends Group {
    pointUuid: string;
}

export default function RoamPathPanel() {
    const { projectUuid, buildingUuid } = useParams();

    const systemContext = useContext(SystemContext)

    const [roamRoutes, setRoamRoutes] = useState<RoamRoute[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    // 激活详情的漫游路线
    const [activeRoute, setActiveRoute] = useState<RoamRoute>(null);
    const activeRouteRef = useRef<RoamRoute>(null);
    const [deletingGroup, setDeletingGroup] = useState<RoamGroup>(null);
    // 漫游所需的变量

    // 关键点的组列表
    const [groups, setGroups] = useState<RoamGroup[]>([]);
    // 下拉选择漫游路线框是否可见
    const [selectRoamRouteVisible, setSelectRoamRouteVisible] = useState<boolean>(false);
    const [selectRoamRouteLeft, setSelectRoamRouteLeft] = useState<number>(0);
    const [selectRoamRouteTop, setSelectRoamRouteTop] = useState<number>(0);

    const titleTextRef = useRef(null);

    // 漫游曲线维护参数
    const roamingRatioRef = useRef<number>(0);  // 当前在曲线中的比例
    const roamingReferTweenRef = useRef(null);  // 当前参考的漫游曲线
    const roamingReferCurveRef = useRef(null);  // 当前参考的漫游曲线
    const roamingIsReverseRef = useRef<boolean>(false);  // 当前漫游曲线是否反向
    const [roamingStatus, setRoamingStatus] = useState(RoamStatus.STOP);  // 当前漫游状态
    const [roamingRatio, setRoamingRatio] = useState<number>(0);  // 当前漫游进度
    const roamingStatusRef = useRef(RoamStatus.STOP);
    const roamingRotateRef = useRef<boolean>(false);    // 当前是否用键盘控制转向
    const roamingIsWsRef = useRef<boolean>(false);    // 当前是否用ws键盘控制

    useEffect(() => {
        roamingStatusRef.current = roamingStatus;
    }, [roamingStatus])

    useEffect(() => {
        roamingRatioRef.current = roamingRatio;
    }, [roamingRatio])

    useEffect(() => {
        document.addEventListener('keydown', onKeydown);
        return () => {
            document.removeEventListener('keydown', onKeydown);
        }
    }, [])

    // 从头开始漫游曲线
    const onStartRoam = (e, roamRoute: RoamRoute) => {
        e.stopPropagation();
        e.preventDefault();
        if (roamingReferTweenRef.current != null) {
            removeAll();
            roamingReferTweenRef.current = null;
            setRoamingStatus(RoamStatus.STOP);
        }
        // 初始化
        setRoamingRatio(0);
        roamingRatioRef.current = 0;
        const points = [];
        roamRoute.entities.forEach(e => {
            points.push(new Vector3(e.position.x, e.position.y, e.position.z));
        })
        // 开启注解可以提供走到头反向漫游
        // if (roamingIsReverseRef.current) {
        //     points.reverse();
        // }
        roamingIsReverseRef.current = false;
        setActiveRoute(roamRoute);
        roamingReferCurveRef.current = new CatmullRomCurve3(points);
        // 漫游曲线变化事件回调
        roamingReferTweenRef.current = createTween(roamRoute, onRoamUpdate, onRoamComplete,
            roamingRatioRef.current);
        // 播放曲线
        roamingReferTweenRef.current.start();
        setRoamingStatus(RoamStatus.PLAY);
        roamAnimate(); // 开始动画
    }

    /**
     * 漫游曲线变化事件回调
     * @param progress 当前在曲线中的比例
     */
    const onRoamUpdate = ({ progress }) => {
        commonMoveCamera(progress);
    }

    // 漫游曲线完成回调
    const onRoamComplete = () => {
        setRoamingStatus(RoamStatus.STOP);
        removeAll();
        roamingReferTweenRef.current = null;
        roamingReferCurveRef.current = null;
        setRoamingRatio(roamingIsReverseRef.current ? 0 : 1)
        // roamingRatioRef.current = roamingIsReverseRef.current ? 0 : 1;
        roamingIsReverseRef.current = !roamingIsReverseRef.current;
    }
    
    const onKeydown = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.key === 'w' || e.key === 's') {
            if (roamingRatioRef.current === 0 || roamingRatioRef.current === 1) return;
            // 漫游状态下，按ws无效
            if (activeRouteRef.current == null || roamingStatusRef.current === RoamStatus.PLAY) return;
            // onWsKeydown(e.key === 'w');
        } else
         if (e.key === 'ArrowUp' || e.key === 'ArrowDown'
            || e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
            e.stopPropagation();
            let vertical;
            let angle;
            if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                vertical = false;
                angle = e.key === 'ArrowUp' ? RoamRotationSpeed : -RoamRotationSpeed;
            } else {
                vertical = true;
                angle = e.key === 'ArrowLeft' ? RoamRotationSpeed : -RoamRotationSpeed;
            }
            roamCameraRotate(angle, vertical);
        } else if (e.key === 'p') {
            if (activeRouteRef.current == null || roamingIsWsRef.current) return;
            onPKeydown();
        }
    }

    const onWsKeydown = (isW: boolean = true) => {
        const activeRoamRoute = activeRouteRef.current;
        if (activeRoamRoute == null) return;
        if (roamingReferTweenRef.current = null) {
            setRoamingRatio(0);
            roamingRatioRef.current = 0;
        }
        if (roamingRatioRef.current === 0 && !isW || roamingRatioRef.current === 1 && isW) return;
        // 创建一条新曲线
        removeAll();
        roamingReferTweenRef.current = null;
        setRoamingStatus(RoamStatus.STOP);
        // 初始化
        const points = [];
        activeRoamRoute.entities.forEach(e => {
            points.push(new Vector3(e.position.x, e.position.y, e.position.z));
        })
        roamingIsReverseRef.current = !isW;
        if (roamingIsReverseRef.current) {
            points.reverse();
        }
        roamingReferCurveRef.current = new CatmullRomCurve3(points);
        let endRatio;
        let startRadio = roamingRatioRef.current;
        if (isW) {
            endRatio = roamingRatioRef.current + 0.1;
        } else {
            startRadio = Math.max(0, 1 - roamingRatioRef.current - 0.1);
            endRatio = 1 - roamingRatioRef.current;
        }
        endRatio = Math.min(1, endRatio);
        // 漫游曲线变化事件回调
        roamingReferTweenRef.current = createTween(activeRoamRoute, ({ progress }) => {
            if (roamingIsReverseRef.current) {
                let realProgress = progress;
                const delta = progress - startRadio;
                const realStart = 1 - endRatio;
                const realEnd = Math.max(0, realStart - 0.1);
                realProgress = realStart - delta;
                setRoamingRatio(realProgress);
                if (realProgress <= realEnd) {
                    setRoamingRatio(0);
                    // roamingRatioRef.current = 1 - realProgress;
                    onWsRoamComplete();
                    return
                }
            }
            // let realProgress = progress;
            commonMoveCamera(progress);
        }, onWsRoamComplete, startRadio, endRatio)
        // 播放曲线
        roamingReferTweenRef.current.start();
        roamingIsWsRef.current = true;
        setRoamingStatus(RoamStatus.PLAY);
        roamAnimate(); // 开始动画
    }

    const commonMoveCamera = (realProgress: number) => {
        const editor = graphicStore.extraContext.getCurrentViewEditor();
        if (!roamingIsReverseRef.current) {
            setRoamingRatio(realProgress);
        }
        // roamingRatioRef.current = realProgress;
        const curve = roamingReferCurveRef.current;
        const point = curve.getPointAt(realProgress);
        point.setZ(point.z + CameraHeight);
        // 获取路径上的切线方向，并设置相机朝向
        const tangent = curve.getTangentAt(realProgress).normalize();
        const position = editor.camera.position;
        // 设置相机坐标
        editor.camera.position.copy(point);
        // 设置视角的方向
        let renderContext = graphicStore.context.renderContext;
        let offset = position.clone().sub(renderContext.viewTarget);
        renderContext.viewTarget.set(tangent.x, tangent.y, tangent.z);
        position.copy(renderContext.viewTarget).add(offset);
        // 设置相机lookat
        let lookat = point.clone().add(tangent);
        editor.camera.lookAt(lookat);
        editor.camera.updateMatrixWorld();
        editor.camera.up = new Vector3(0, 0, 1);
        (editor.camera as (OrthographicCamera | PerspectiveCamera)).updateProjectionMatrix();
        editor.listeners.signals.needRender.dispatch();
    }

    const onWsRoamComplete = () => {
        setRoamingStatus(RoamStatus.STOP);
        removeAll();
        roamingReferTweenRef.current = null;
        roamingReferCurveRef.current = null;
        const target = roamingIsReverseRef.current ? 0 : 1;
        if (roamingRatioRef.current - target < 1e-6) {
            // 设置反向
            roamingIsReverseRef.current = !roamingIsReverseRef.current;
        }
        roamingIsWsRef.current = false;
    }

    const onPKeydown = () => {
        if (roamingRatioRef.current === 1) return;
        // 当前没有播放的曲线或者已经结束，重新创建曲线
        const roamRoute = activeRouteRef.current;
        roamingIsReverseRef.current = false;
        // stop状态只存在于从未播放过、播放结束、ws后，都不需要重置当前ratio
        if (roamingReferTweenRef.current == null || roamingStatusRef.current === RoamStatus.STOP) {
            const points = [];
            roamRoute.entities.forEach(e => {
                points.push(new Vector3(e.position.x, e.position.y, e.position.z));
            })
            let target = 1;
            roamingReferCurveRef.current = new CatmullRomCurve3(points);
            // 漫游曲线变化事件回调
            roamingReferTweenRef.current = createTween(roamRoute, onRoamUpdate, onRoamComplete,
                roamingRatioRef.current, target);
            // 播放曲线
            roamingReferTweenRef.current.start();
            setRoamingStatus(RoamStatus.PLAY);
            roamAnimate(); // 开始动画
            return;
        }
        // 当前正在播放，那么暂停
        if (roamingStatusRef.current === RoamStatus.PLAY) {
            roamingReferTweenRef.current.pause();
            setRoamingStatus(RoamStatus.PAUSE);
        } else if (roamingStatusRef.current === RoamStatus.PAUSE) {
            roamingReferTweenRef.current.resume();
            setRoamingStatus(RoamStatus.PLAY);
        }
    }

    useEffect(() => {
        return () => {
            if (!!roamingReferTweenRef.current) {
                removeAll()
            }
        }
    }, [])

    useEffect(() => {
        activeRouteRef.current = activeRoute;
        const groupUuids = [];
        if (!!activeRoute) {
            // 遍历点，获取关键点，找到组名
            for (let p of activeRoute.entities) {
                if (p.isKeyPoint == null || !p.isKeyPoint || p.group == null
                    || Object.keys(p.group).length === 0 || p.group[7] == null
                    || p.group[7][0] == null) continue;
                groupUuids.push(p.group[7][0]);
            }
        }
        // 遍历获取组详情
        if (groupUuids.length === 0) {
            setGroups([]);
            return;
        }
        setLoading(true);
        const roamGroups: RoamGroup[] = [];
        getGroupByUuids(projectUuid, groupUuids).then((res) => {
            let data = res.data || [];
            let groupMap = {};
            data.forEach(g => {
                groupMap[g?.uuid] = g;
            });
            for (let p of activeRoute.entities) {
                if (p.isKeyPoint == null || !p.isKeyPoint || p.group == null
                    || Object.keys(p.group).length === 0 || p.group[7] == null
                    || p.group[7][0] == null) continue;
                const group = groupMap[p.group[7][0]];
                if (group == null) continue;
                roamGroups.push({
                    ...group,
                    pointUuid: p.uuid
                })
            }
        }).catch(err => {
            message.error("获取组详情失败");
        }).finally(() => {
            setGroups(roamGroups);
            setLoading(false);
        })
    }, [activeRoute])

    useEffect(() => {
        if (!projectUuid || !buildingUuid) return;
        generateData();
    }, [projectUuid, buildingUuid])

    useEffect(() => {
        if (systemContext.currentCameraType === CAMERA_TYPE.Orthographic) {
            systemContext.setCurrentCameraType(CAMERA_TYPE.Perspective);
        }
        return () => {
            systemContext.setCurrentCameraType(CAMERA_TYPE.Orthographic);
        }
    }, [])

    // 获取路由线路
    const generateData = () => {
        setLoading(true);

        findRoamRoutesByBuilding(projectUuid, buildingUuid)
            .then(res => {
                setRoamRoutes(res.data || []);
            }).catch(err => {
                message.error("获取数据失败");
            }).finally(() => {
                setLoading(false);
            })
    }

    // 删除关键点
    const deleteGroup = (group: RoamGroup) => {
        if (group == null || group.pointUuid == null || group.pointUuid === '') {
            message.warning("要删除的组信息有误");
            return;
        }
        // TODO 删除弹窗
        setDeletingGroup(group);
    }

    // 删除关键点
    const updateKeyPoint = () => {
        const pointIndex = activeRoute.entities
            .findIndex(p => p.uuid === deletingGroup.pointUuid);
        activeRoute.entities[pointIndex] = {
            ...activeRoute.entities[pointIndex],
            isKeyPoint: false,
            groupIds: [],
        }
        setLoading(true);
        updateRoamRoutes(activeRoute.uuid, activeRoute).then(res => {
            if (res.status === 200) {
                message.success("删除组成功");
                const roamIndex = roamRoutes.findIndex(r => r.uuid === activeRoute.uuid);
                roamRoutes[roamIndex] = activeRoute;
                setRoamRoutes([...roamRoutes]);
                setGroups([...groups.filter(g => g.uuid !== deletingGroup.uuid)]);
                return;
            }
            message.error("删除组失败")
        }).catch(err => {
            message.error("删除组失败");
        }).finally(() => {
            setLoading(false);
            setDeletingGroup(null);
        })
    }

    // 漫游到关键点
    const roam2Point = (group: RoamGroup) => {
        // const point = activeRoute.entities.find(p => p.uuid === group.pointUuid);
        // if (!point) {
        //     message.warning("关键点不存在");
        //     return;
        // }
        // let closeDistance = Number.MAX_VALUE;
        // const pointPos = new Vector3(point.position.x, point.position.y, point.position.z);
        // let closeIndex = 0; // 最接近point的索引
        // for (let index = 0; index < roamingPointsRef.current.length; index++) {
        //     const splitPoint = roamingPointsRef.current[index];
        //     const splitDistance = splitPoint.distanceTo(pointPos);
        //     if (splitDistance < closeDistance) {
        //         closeDistance = splitDistance;
        //         closeIndex = index;
        //     }
        // }
        // if (closeIndex === roamingIndexRef.current) return;
        // if (roamingTweenRef.current != null) {
        //     removeAll();
        //     roamingTweenRef.current = null;
        // }
        // roamMove(RoamTime, roamingPointsRef.current, roamingIndexRef.current, closeIndex,
        //     () => roamingIndexRef.current = closeIndex, CameraHeight);
    }

    const [roamingManLeft, setRoamingManLeft] = useState(0);
    const [roamingBarWidth, setRoamingBarWidth] = useState(0);

    useEffect(() => {
        if (roamingRatio === 0 || roamingRatio === 1) return;
        let ratio = roamingRatio;
        setRoamingManLeft(-14 + ratio * 210);
        setRoamingBarWidth(ratio * 100);
    }, [roamingRatio])

    return (
        <div className='roam-path-panel'>
            {<div className='roam-path-list'>
                {roamRoutes.map(roam => {
                    return <div className={classNames({
                        'roam-path-item': true,
                        'active': activeRoute?.uuid === roam.uuid
                    })} key={roam.uuid} onClick={() => setActiveRoute(roam)}>
                        <div className='name ellipsis'>{roam.name}</div>
                        {(activeRoute?.uuid !== roam.uuid ||
                            (activeRoute?.uuid === roam.uuid && RoamStatus.STOP === roamingStatus))
                            && <div className='ope-icon' onClick={(e) => onStartRoam(e, roam)}><RoamSvg /></div>}
                        {activeRoute?.uuid === roam.uuid && RoamStatus.PAUSE === roamingStatus &&
                            <div className='ope-icon' onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                if (activeRouteRef.current == null || roamingIsWsRef.current) return;
                                onPKeydown();
                            }}><PlaySvg /></div>}
                        {activeRoute?.uuid === roam.uuid && RoamStatus.PLAY === roamingStatus &&
                            <div className='ope-icon' onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                if (activeRouteRef.current == null || roamingIsWsRef.current) return;
                                onPKeydown();
                            }}><PauseSvg /></div>}
                    </div>
                })}
            </div>}
            {!!activeRoute && false && <div className='roam-path-detail'>
                <div className='title'>
                    <div className='title-back-svg' onClick={() => setActiveRoute(null)} ><BackSvg /></div>
                    <div className='title-text' onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        if (titleTextRef.current) {
                            const rect = titleTextRef.current.getBoundingClientRect();
                            setSelectRoamRouteTop(rect.bottom + 8);
                            setSelectRoamRouteLeft(rect.left - 8);
                        }
                        setSelectRoamRouteVisible(true);
                    }}>
                        <div className='text ellipsis' ref={titleTextRef}>{activeRoute?.name}</div>
                        <div className='title-select-svg'>
                            <TitleSelectOpenSvg />
                        </div>
                    </div>
                    {/* <div className='title-roam-svg'><TitleRoamSvg /></div> */}
                    {/* {isPause == null && <div className='title-roam-svg' onClick={(e) => {
                        roamSelectPath(e, activeRoute);
                    }}><TitleRoamSvg /></div>}
                    {isPause != null && isPause == true && <div className='title-roam-svg' onClick={() => {
                        setIsPause(false);
                        if (roamingTweenRef.current != null) {
                            roamingTweenRef.current.pause();
                        }
                    }}><PauseSvg /></div>}
                    {isPause != null && isPause == false && <div className='title-roam-svg' onClick={() => {
                        setIsPause(true);
                        if (roamingTweenRef.current != null) {
                            roamingTweenRef.current.resume();
                        };
                    }}><PauseSvg /></div>} */}
                </div>
                <div className='group-list'>
                    {groups.map((group, index) => {
                        return (
                            <div className='group-item' key={group.uuid}>
                                <div className='group-index'>{index + 1}</div>
                                <div className='group-detail'>{group?.name}</div>
                                <div className='group-opes'>
                                    <div className='group-ope'>
                                        <RoamSvg onClick={() => roam2Point(group)} />
                                    </div>
                                    {/* <div className='group-ope'>
                                        <DeleteSvg onClick={() => deleteGroup(group)} />
                                    </div> */}
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>}
            <div className='roam-tip'>
                <img src={require('./png/roam-ope-tip.png')} />
            </div>
            {activeRoute != null && roamingRatio > 0 && roamingRatio < 1 &&
                <div className='roam-process'>
                    <div className='roam-process-bar' style={{ width: `${roamingBarWidth}%` }} />
                    <div className='roam-process-man'
                        style={{ left: `${roamingManLeft}px` }}>
                        <RoamManSvg /></div>
                </div>}

            <ContextMenuFC visible={selectRoamRouteVisible} left={selectRoamRouteLeft} top={selectRoamRouteTop}
                width={148}
                onCancel={() => setSelectRoamRouteVisible(false)} wrapperClassname='roam-path-select-menu'>
                {roamRoutes.map(roamRoute => {
                    return <div key={roamRoute.uuid} className='roam-path-select-menu-item'
                        onClick={() => {
                            setSelectRoamRouteVisible(false);
                            if (roamRoute?.uuid === activeRoute?.uuid) return;
                            setActiveRoute(roamRoute);
                        }}>
                        {roamRoute.name}
                    </div>
                })}
            </ContextMenuFC>
            {/* <div className='roam-path-ope'>
                <div className='svg'>+</div>
                <div className='text'>新建线路</div>
            </div> */}
        </div>
    )
}
